import { View, ViewStyle, Platform, TextStyle } from "react-native"

import { colors } from "@/theme"

import { Text } from "./Text"

interface InspectionDateCardProps {
  date: Date | null
  style?: ViewStyle
}

export const InspectionDateCard: React.FC<InspectionDateCardProps> = ({ date, style }) => {
  if (!date) return null

  const formatDate = (date: Date): string => {
    return date.toLocaleDateString("de-DE", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
  }

  return (
    <View style={[$container, style]}>
      <Text style={$dateText} size="xs" weight="medium">
        {formatDate(date)}
      </Text>
    </View>
  )
}

const $container: ViewStyle = {
  backgroundColor: colors.surface,
  borderRadius: 12,
  paddingHorizontal: 12,
  paddingVertical: 8,
  alignItems: "center",
  justifyContent: "center",
  minWidth: 80,
  ...Platform.select({
    web: {
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
    },
    default: {
      shadowColor: colors.text,
      shadowOffset: {
        width: 0,
        height: 2,
      },
      shadowOpacity: 0.1,
      shadowRadius: 4,
      elevation: 3,
    },
  }),
}

const $dateText: TextStyle = {
  color: colors.text,
  lineHeight: 16,
}
